import React from 'react'
import EmailIcon from "@material-ui/icons/Email";
import GithubIcon from "@material-ui/icons/GitHub";
import profilepictop from "../assets/ProfilePic.jpeg"
// import programmerpicright from "../assets/programmerpic.png"

const Home = () => {
  return (
    <>
      <div className=' bg-gradient-to-r from-cyan-200 to-cyan-700 text-center  h-[40rem] flex items-center justify-center font-bold '>

        <div>
          <div className='relative left-1/2 transform -translate-x-1/2  w-40 h-40 lg:w-60 lg:h-60 md:w-52 md:h-52'>
            <img src={profilepictop} alt="Profile" className="w-full h-full rounded-full object-cover" />
          </div>

          <div className='mt-10'>
            <h1 className='text-7xl text-orange-950 font-serif'>Hey, My Name Is Moshe</h1>
            <h1 className='pt-5 text-2xl mr-3 ml-3 text-orange-950 font-mono'>A computer science student, specializing in Web Development</h1>
          </div>

          <div className='mt-5'>
            {/* <a href='https://github.com/MosheBens' target="_blank" rel="noopener noreferrer" className='mr-20'>
                <GithubIcon className='text-black hover:text-slate-600' style={{ fontSize: 50 }}/>
            </a>

            <a href='mailto:moshe123bs@gmail.com'>
                <EmailIcon className=' text-black hover:text-slate-600' style={{ fontSize: 50 }}/>
            </a> */}
            <a href="https://github.com/MosheBens" className="bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 focus:outline-none focus:shadow-outline-gray active:bg-gray-900 mr-12" target="_blank" rel="noopener noreferrer">
                <GithubIcon className=' text-white hover:text-gray-400 mr-2 mb-1' style={{ fontSize: 30 }}/>
                GitHub
            </a>
            <a href="mailto:moshe123bs@gmail.com" className="bg-blue-800 text-white py-2 px-6 rounded-md hover:bg-gray-700 focus:outline-none focus:shadow-outline-gray active:bg-gray-900" target="_blank" rel="noopener noreferrer">
                <EmailIcon className=' text-white hover:text-blue-800 mr-2 mb-1' style={{ fontSize: 35 }}/>
                Email
            </a>
          </div>
        </div>
      </div> 

      {/* ----------- */}
      <div className="lg:flex  bg-gradient-to-r from-teal-100 to-teal-600 h-[115rem] lg:h-[45rem] md:h-[115rem] pt-10  text-xl">
        <div className="w-full lg:w-1/3 p-4 text-center md:items-start">
          <div>
            <h3 className="text-2xl font-bold mb-8">Languages</h3>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 lg:w-10 lg:h-10" src="https://cdn3.iconfinder.com/data/icons/logos-and-brands-adobe/512/267_Python-512.png" alt="python-img"/>
              <div>Python</div>
            </div>
 
            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 ml-6 lg:w-10 lg:h-10" src="https://cdn.iconscout.com/icon/free/png-512/javascript-2752148-2284965.png" alt="JavaScript-icon"/>
              <div>JavaScript</div>
            </div>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 lg:w-10 lg:h-10" src="https://www.cdnlogo.com/logos/c/27/c.svg" alt="C#-icon"/>
              <div className='mr-10'>C#</div>
            </div>

            <div className="flex items-center justify-center mb-4 mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 lg:w-10 lg:h-10" src="https://cdn.iconscout.com/icon/free/png-512/c-programming-569564.png" alt="C-icon"/>
              <div className='mr-12'>C</div>&nbsp;
            </div>

            <div className="flex items-center justify-center mb-4 mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 lg:w-10 lg:h-10" src="https://img.icons8.com/color/452/c-plus-plus-logo.png" alt="C++-icon"/>
              <div className='mr-6'>C++</div>
            </div>
            
          </div>
        </div>

        <div className="w-full lg:w-1/3 p-4 text-center sm:items-start">
          <div className="skillsSection_rowContainer__sk9m3">
            <h3 className="text-2xl font-bold mb-8">Web Development</h3>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 lg:w-10 lg:h-10" src="https://cdn.iconscout.com/icon/free/png-512/html-2752158-2284975.png" alt="HTML-icon"/>
              <div>HTML</div>
            </div>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 lg:w-10 lg:h-10" src="https://cdn.iconscout.com/icon/free/png-512/css3-9-1175237.png" alt="CSS-icon"/>
              <div className='mr-5'>CSS</div>
            </div>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 ml-3 lg:w-10 lg:h-10" src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/React_Logo_SVG.svg/640px-React_Logo_SVG.svg.png" alt="ReactJS-icon"/>
              <div>ReactJS</div>
            </div>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 lg:w-10 lg:h-10" src="https://img.icons8.com/color/452/npm.png" alt="NPM-icon"/>
              <div className='mr-2'>NPM</div>
            </div>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 ml-9 lg:w-10 lg:h-10" src="https://img.icons8.com/color/452/bootstrap.png" alt="Bootstrap-icon"/>
              <div>BootStrap</div>
            </div>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
            &nbsp;<img className="w-12 h-12   mr-2 ml-12 lg:w-10 lg:h-10" src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/1200px-Tailwind_CSS_Logo.svg.png" alt="Tailwind CSS-icon"/>
              <div>TailwindCSS</div>
            </div>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 ml-4 lg:w-10 lg:h-10" src="https://img.icons8.com/color/452/nodejs.png" alt="Node.js-icon"/>
              <div>NodeJS</div>
            </div>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12  mr-2 ml-8 lg:w-10 lg:h-10" src="https://posistrength.com/upload/m_631d94d1e6e1d_8a8925c73516e615b97bb2c5a43df070.png" alt="Express.js-icon"/>
              <div>ExpressJS</div>
            </div>
            
            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12   mr-2 ml-10 lg:w-10 lg:h-10" src="https://img.icons8.com/color/452/mongodb.png" alt="MongoDB-icon"/>
              <div>MongoDB</div>
            </div>

            <div className="flex items-center justify-center mb-4  mr-20 lg:mr-0">
              <img className="w-12 h-12 mr-2 ml-5 lg:w-10 lg:h-10" src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Firebase_icon.svg/2048px-Firebase_icon.svg.png" alt="Firebase-icon"/>
              <div>FireBase</div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-1/3 p-4 text-center sm:items-start">
          <div className="skillsSection_rowContainer__sk9m3">
            <h3 className="text-2xl font-bold mb-8">Knowledge in</h3>

            <div className="flex items-center justify-center mb-4">
              <img className="w-12 h-12   mr-2 lg:w-10 lg:h-10" src="https://cdn.iconscout.com/icon/premium/png-256-thumb/data-structure-1861576-1578307.png?f=webp" alt="Data Structures-icon"/>
              <div>Data Structures</div>
            </div>

            <div className="flex items-center justify-center mb-4">
              
              <img className="w-12 h-12   mr-2 lg:w-10 lg:h-10" src="https://cdn-icons-png.flaticon.com/512/2172/2172943.png" alt="Algorithms-img"/>
              <div className='mr-10'>Algorithms</div>
            </div>

            <div className="flex items-center justify-center mb-4">
              <img className="w-12 h-12   mr-2 ml-8 lg:w-10 lg:h-10" src="https://cdn-icons-png.flaticon.com/512/2172/2172894.png" alt="OperatingSystems-img"/>
              <div>Operating Systems</div>
            </div>

            <div className="flex items-center justify-center mb-4">
            &nbsp;&nbsp;<img className="w-12 h-12  mr-2  ml-16 sm:ml-20  lg:ml-16 xl:ml-20 lg:w-10 lg:h-10" src="https://cdn-icons-png.flaticon.com/512/4668/4668912.png" alt="Communicationnetworks-img"/>
              <div>Communication networks</div>
            </div>

            <div className="flex items-center justify-center mb-4">
              <img className="w-12 h-12   mr-2 ml-10 lg:w-10 lg:h-10" src="https://www.tridentspark.com/wp-content/uploads/2023/07/mern-stack-icon-1.png" alt="MERN-img"/>
              <div>FullStack MERN APP</div>
            </div>

            <div className="flex items-center justify-center mb-4">
              <img className="w-12 h-12   mr-2 ml-8 lg:w-10 lg:h-10" src="https://cdn-icons-png.flaticon.com/512/4248/4248245.png" alt="OOP-img"/>
              <div className='mr-32'>OOP</div>
            </div>

            <div className="flex items-center justify-center mb-4">
              <img className="w-12 h-12   mr-2 ml-8 lg:w-10 lg:h-10" src="https://cdn-icons-png.flaticon.com/512/25/25231.png" alt="Github-img"/>
              <div className='mr-28'>GitHub</div>
            </div>

            <div className="flex items-center justify-center mb-4">
              <img className="w-12 h-12   mr-2 ml-8 lg:w-10 lg:h-10" src="https://cdn-icons-png.flaticon.com/512/8297/8297102.png" alt="CleanCode-img"/>
              <div className='mr-16'>Clean Code</div>
            </div>
            
          </div>
        </div>
      </div>


      {/* <div className='bg-gradient-to-r from-teal-100 to-teal-600 text-center h-[45rem] md:grid md:grid-cols-2'>
        <div className="skills">
          <h1 className='text-5xl font-bold pt-5'> Skills:</h1>
          <ol className="list mt-10 w-[60%] text-start ml-24">
            <li>
              <h2 className='text-2xl font-bold'> Front-End:</h2>
              <span className='mt-4'>
                ReactJS, HTML, CSS, NPM, 
                BootStrap, TailwindCSS.
              </span>
            </li>
            <li className="mt-10">
              <h2 className='text-2xl font-bold'>Back-End:</h2>
              <span className='mt-2'>
                NodeJS, ExpressJS,
                MongoDB.
              </span>
            </li>
            <li className="mt-10">
              <h2 className='text-2xl font-bold'>Languages:</h2>
              <span className='mt-2'>
              JavaScript ,
              Python ,
              C#,
              C ,
              C++,
              Java.
              </span>
            </li>
            <li className="mt-10">
              <h2 className='text-2xl font-bold'>Others:</h2>
              <span className='mt-2'>
                Linux,
                Firebase,
                API,
                GIT,
                OOP,
                Clean Code.
              </span>
            </li>
            <li className="mt-10">
              <h2 className='text-2xl font-bold'>Knowledge In:</h2>
              <span className='mt-2'>
                Data Structures,
                Algorithms,
                Operating Systems,
                Communication networks,
                fullstack MERN APP.
              </span>
            </li>
          </ol>
        </div>

        <div className='text-center flex items-center justify-center'>
          <div style={{ backgroundImage: `url(${programmerpicright})` }} className='spacialu bg-cover h-0  w-0 sm:w-0 md:w-80 lg:w-96 sm:h-0 md:h-52 lg:h-60  rounded-md' />
        </div>

      </div> */}
      {/* {{ backgroundImage: `url(${image})` }} */}
      

      <footer className="h-[4rem] text-center flex items-center justify-center bg-gradient-to-r from-amber-100 to-amber-400">
          <div className="w-full mx-auto max-w-screen-xl p-4">
            <span >
              © 2024 . Copyright Moshe Ben Shimol.
            </span>
          </div>
      </footer>
    </>
  )
}

export default Home